import * as React from 'react';

function SvgDeliveryOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M16 3h2.385a3 3 0 012.949 3.553l-2.028 10.816A2 2 0 0117.34 19h-.84M7 19h4" }),
        React.createElement("circle", { cx: 14, cy: 17, r: 3.2, stroke: "currentColor", strokeWidth: 1.6 }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M11 6H6.5M8.5 10.5H4M6.5 14.5H2" })));
}

export default SvgDeliveryOutline;
